import React from "react";
import { Container } from "react-bootstrap";
import { useIsMobile } from "../../utils/responsive";

export default function Banner1() {
  const isMobile = useIsMobile();
  return (
    <Container fluid className="p-0">
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
        <div
          className={`border-bottom-black `}
          style={{
            width: isMobile ? "100%" : "90%",
            borderBottom: "1px solid black",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 150px",
            }}
          >
            <p className="body-lg m-0">
              "GREAT DESIGN IS NOT JUST ABOUT HOW A SPACE LOOKS,
              <span className="accent-text">
                &nbsp;but how it makes you feel
              </span>{" "}
              <br />
              <span>
                WHERE FUNCTIONALITY SEAMLESSLY DANCES WITH AESTHETICS."
              </span>
            </p>
          </div>
        </div>
        {!isMobile && (
          <div
            className="border-bottom-black border-left-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
